module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-199.d035420.woff2";